<template>
  <div class="error-block">
    <i class="icon fa fa-frown-o"/>
    <p><slot>Sorry but something went wrong!</slot></p>
    <p v-if="buttonCallback">
      <el-button @click="buttonCallback"><i class="fa fa-repeat"/> {{ buttonText }}</el-button>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'ErrorBlock',
    props: {
      buttonCallback: {
        type: Function,
      },
      buttonText: {
        type: String,
        default: 'Reload',
      },
    },
  };
</script>

<style lang="scss">
  .error-block {
    text-align: center;
    color: #CCC;
    .icon {
      font-size: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorBlock.vue